module.exports = __webpack_public_path__ + "img/antes_despues_46.4c2ddd58.png";